import Select from "react-select";
import { SelectOption } from "./select-input";
import { CSSProperties } from "react";

interface SearchSelectProps {
    label?: string;
    options: SelectOption[];
    value: any;
    onChange: (value: SelectOption | null) => void;
    error?: boolean
    message?: string,
    name?: string,
    placeholder?: string,
    className?: string
    containerStyle?: CSSProperties
    inputStyle?: CSSProperties
    onMenuOpen?: () => void
    onMenuClose?: () => void
    onKeyDown?: (e: React.KeyboardEvent) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    clearable?: boolean
    // Renders the menu on top of the page so it isn't clipped by a modal or scroll container.
    menuPortal?: boolean
    // Shows a spinner and "Loading..." in the menu while the options are being fetched.
    isLoading?: boolean
}

const SearchSelect: React.FC<SearchSelectProps> = ({
    label,
    options,
    value,
    onChange,
    error,
    message,
    name,
    placeholder,
    className,
    containerStyle,
    inputStyle,
    onMenuOpen,
    onMenuClose,
    onKeyDown,
    onBlur,
    clearable,
    menuPortal,
    isLoading
}) => {
    return (
        <div style={containerStyle} className={`input-container ${error ? 'error' : ''} ${className ?? ''}`}>
            {label && <span className="input-label">{label}</span>}
            <Select
                name={name}
                className="input p-0"
                placeholder={placeholder}
                options={options}
                value={options.filter(o => o.value === value) ?? null}
                onChange={onChange}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                isSearchable
                isClearable={clearable}
                isLoading={isLoading}
                loadingMessage={() => "Loading..."}
                menuPortalTarget={menuPortal ? document.body : undefined}
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                        ...base,
                        backgroundColor: "var(--bs-body-bg)",
                        border: 'none',
                    }),
                    menu: (base) => ({
                        ...base,
                        backgroundColor: "var(--bs-body-bg)",
                        zIndex: 9999,
                    }),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? "var(--bs-secondary-bg)" : "var(--bs-body-bg)",
                        color: "var(--bs-body-color)",
                    }),
                    singleValue: (base) => ({
                        ...base,
                        color: "var(--bs-body-color)",
                    }),
                    input: (base) => ({
                        ...base,
                        color: "var(--bs-body-color)",
                        padding: '0px',
                    }),
                    container: (base) => ({
                        ...base,
                        ...inputStyle
                    })
                }}
            />
            {message && <span className="input-message">{message}</span>}
        </div>
    );
};


export default SearchSelect